import { render } from "./ModalWishList.vue?vue&type=template&id=74a05e50&scoped=true"
import script from "./ModalWishList.vue?vue&type=script&lang=js"
export * from "./ModalWishList.vue?vue&type=script&lang=js"

import "./ModalWishList.vue?vue&type=style&index=0&id=74a05e50&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a05e50"]])

export default __exports__